import { Component } from '@angular/core';
import { SidebarComponent } from '../../components/sidebar/sidebar.component';
import { RouterOutlet } from '@angular/router';
import { GlobalService } from '../../services/global.service';
import { IdleTimeoutComponent } from '../../components/idle-timeout/idle-timeout.component';
import { UserService } from '../../services/user.service';

@Component({
    selector: 'app-dashboard-layout-page',
    imports: [SidebarComponent, RouterOutlet, IdleTimeoutComponent],
    templateUrl: './dashboard-layout-page.component.html',
    standalone: true,
})
export class DashboardLayoutPageComponent {

    constructor(public gs: GlobalService, private us: UserService) { }

    async ngOnInit() {
        const user_id = this.gs.user_data?.id;
        if (!user_id) return;
        try {
            const role_data = await this.us.get(user_id);
            const fresh_university = role_data.data?.University || {};
            this.gs.university_settings = fresh_university;
            localStorage.setItem('university_settings', JSON.stringify(fresh_university));
        } catch { }
    }
}
